import { Route } from 'react-router-dom'
import { PaymentPageType } from '../types/mf-execution.types'

// ===== CRITICAL ROUTES - REGULAR IMPORTS (NO SUSPENSE) =====
// These are the most frequently used routes that should never show loading
import BuyPaymentPage from '../pages/execution/buy/BuyPaymentPage'
import SIPPaymentPage from '../pages/execution/sip/SIPPaymentPage'
import WithdrawPaymentPage from '../pages/execution/withdraw/WithdrawPaymentPage'
import { FolioSelectionPage } from '../pages/execution/withdraw/FolioSelectionPage'

// ===== BUY ROUTES =====
import { BuyOTPPage } from '../pages/execution/buy/BuyOTPPage'
import { BuyAddUpiPage } from '../pages/execution/buy/BuyAddUpiPage'
import BuyPaymentMethodsScreen from '../pages/execution/buy/BuyPaymentMethodsScreen'
import SIPPaymentMethodsScreen from '../pages/execution/sip/SIPPaymentMethodsScreen'

// ===== SIP ROUTES =====
import { SIPOTPPage } from '../pages/execution/sip/SIPOTPPage'
import { SIPAddUpiPage } from '../pages/execution/sip/SIPAddUpiPage'

// ===== WITHDRAW ROUTES =====
import { WithdrawOTPPage } from '../pages/execution/withdraw/WithdrawOTPPage'
import WithdrawSuccessPage from '../pages/execution/withdraw/WithdrawSuccessPage'
import WithdrawFailedPage from '../pages/execution/withdraw/WithdrawFailedPage'

// ===== SWP ROUTES =====
// import SWPPaymentPage from '../pages/execution/swp/SWPPaymentPage'
// import { SWPOTPPage } from '../pages/execution/swp/SWPOTPPage'

// ===== TRANSFER ROUTES =====
// import TransferPaymentPage from '../pages/execution/transfer/TransferPaymentPage'
// import { TransferOTPPage } from '../pages/execution/transfer/TransferOTPPage'

// ===== BUY STATIC ROUTES =====
import { BuyPaymentFailedPage } from '../pages/execution/buy/BuyPaymentFailedPage'
import { BuyOrderSuccessPage } from '../pages/execution/buy/BuyOrderSuccessPage'
import { BuyNetBankingLinkWaitingPage } from '../pages/execution/buy/net-banking/BuyNetBankingLinkWaitingPage'
import { BuyNetBankPaymentStatusPage } from '../pages/execution/buy/net-banking/BuyNetBankPaymentStatusPage'
import { BuyUPIPaymentStatusPage } from '../pages/execution/buy/upi/BuyUPIPaymentStatusPage'

// ===== SIP STATIC ROUTES =====
import { SIPOrderSuccessPage } from '../pages/execution/sip/SIPOrderSuccessPage'
import { SIPPaymentFailedPage } from '../pages/execution/sip/SIPPaymentFailedPage'
import { SIPNetBankingLinkWaitingPage } from '../pages/execution/sip/net-banking/SIPNetBankingLinkWaitingPage'
import { SIPNetBankPaymentStatusPage } from '../pages/execution/sip/net-banking/SIPNetBankPaymentStatusPage'
import { SIPUPIPaymentStatusPage } from '../pages/execution/sip/upi/SIPUPIPaymentStatusPage'

// ===== SIP AUTO-PAY ROUTES =====
import { AutoPayMethodsPage } from '../pages/execution/sip/auto-pay/AutoPayMethodsPage'
import { SetupAutoPay } from '../pages/execution/sip/auto-pay/SetupAutoPay'
import SetupAutopayMethodsScreen from '../pages/execution/sip/auto-pay/SetupAutopayMethodsScreen'
import { AutoPayStatusPage } from '../pages/execution/sip/auto-pay/AutoPayStatusPage'
import { AutoPayLinkWaitingPage } from '../pages/execution/sip/auto-pay/AutoPayLinkWaitingPage'
import { AutoPayUpiLinkWaitingPage } from '../pages/execution/sip/auto-pay/AutoPayUpiLinkWaitingPage'
import { AutoPayPaymentFailedPage } from '../pages/execution/sip/auto-pay/AutoPayPaymentFailedPage'

// ===== WITHDRAW STATIC ROUTES =====
import { ExitLoadPage } from '../pages/execution/ExitLoadPage'
import { TaxLiabilityPage } from '../pages/execution/TaxLiabilityPage'

export const PaymentRoutes = () => {
  return [
    // Buy Routes
    <Route key='buy-payment' path={`/mutual-fund/:isin/payment/${PaymentPageType.BUY}`} element={<BuyPaymentPage />} />,
    <Route key='buy-otp' path={`/mutual-fund/:isin/payment/${PaymentPageType.BUY}/otp`} element={<BuyOTPPage />} />,
    <Route
      key='buy-add-upi'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.BUY}/add-upi`}
      element={<BuyAddUpiPage />}
    />,
    <Route
      key='buy-upi-intents'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.BUY}/upi-intents`}
      element={<BuyPaymentMethodsScreen />}
    />,

    // SIP Routes
    <Route key='sip-payment' path={`/mutual-fund/:isin/payment/${PaymentPageType.SIP}`} element={<SIPPaymentPage />} />,
    <Route key='sip-otp' path={`/mutual-fund/:isin/payment/${PaymentPageType.SIP}/otp`} element={<SIPOTPPage />} />,
    <Route
      key='sip-add-upi'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.SIP}/add-upi`}
      element={<SIPAddUpiPage />}
    />,
    <Route
      key='sip-upi-intents'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.SIP}/upi-intents`}
      element={<SIPPaymentMethodsScreen />}
    />,

    // Withdraw Routes
    <Route
      key='withdraw-folio-selection'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.WITHDRAW}/folio-selection`}
      element={<FolioSelectionPage />}
    />,
    <Route
      key='withdraw-payment'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.WITHDRAW}`}
      element={<WithdrawPaymentPage />}
    />,
    <Route
      key='withdraw-otp'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.WITHDRAW}/otp`}
      element={<WithdrawOTPPage />}
    />,
    <Route
      key='withdraw-success'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.WITHDRAW}/success`}
      element={<WithdrawSuccessPage />}
    />,
    <Route
      key='withdraw-failed'
      path={`/mutual-fund/:isin/payment/${PaymentPageType.WITHDRAW}/failed`}
      element={<WithdrawFailedPage />}
    />

    // SWP Routes
    // <Route key='swp-payment' path={`/mutual-fund/:isin/payment/${PaymentPageType.SWP}`} element={<SWPPaymentPage />} />,
    // <Route key='swp-otp' path={`/mutual-fund/:isin/payment/${PaymentPageType.SWP}/otp`} element={<SWPOTPPage />} />,

    // Transfer Routes
    // <Route
    //   key='transfer-payment'
    //   path={`/mutual-fund/:isin/payment/${PaymentPageType.TRANSFER}`}
    //   element={<TransferPaymentPage />}
    // />,
    // <Route
    //   key='transfer-otp'
    //   path={`/mutual-fund/:isin/payment/${PaymentPageType.TRANSFER}/otp`}
    //   element={<TransferOTPPage />}
    // />
  ]
}

export const PaymentStaticRoutes = () => {
  return [
    // Buy Routes
    <Route
      key='buy-payment-failed'
      path={`${PaymentPageType.BUY}/payment-failed`}
      element={<BuyPaymentFailedPage />}
    />, // no query params required
    <Route key='buy-order-success' path={`${PaymentPageType.BUY}/order-success`} element={<BuyOrderSuccessPage />} />, // no query params required
    <Route
      key='buy-net-banking-link-waiting'
      path={`${PaymentPageType.BUY}/net-banking/link-waiting`}
      element={<BuyNetBankingLinkWaitingPage />}
    />, // query: orderId
    <Route
      key='buy-net-banking-payment-status'
      path={`${PaymentPageType.BUY}/net-banking/payment-status`}
      element={<BuyNetBankPaymentStatusPage />}
    />, // query: orderId
    <Route
      key='buy-upi-payment-status'
      path={`${PaymentPageType.BUY}/upi/payment-status`}
      element={<BuyUPIPaymentStatusPage />}
    />, // query: orderId

    // SIP Routes
    <Route key='sip-order-success' path={`${PaymentPageType.SIP}/order-success`} element={<SIPOrderSuccessPage />} />, // no query params required
    <Route
      key='sip-payment-failed'
      path={`${PaymentPageType.SIP}/payment-failed`}
      element={<SIPPaymentFailedPage />}
    />, // no query params required
    <Route
      key='sip-net-banking-link-waiting'
      path={`${PaymentPageType.SIP}/net-banking/link-waiting`}
      element={<SIPNetBankingLinkWaitingPage />}
    />, // query: sxpId
    <Route
      key='sip-net-banking-payment-status'
      path={`${PaymentPageType.SIP}/net-banking/payment-status`}
      element={<SIPNetBankPaymentStatusPage />}
    />, // query: sxpId
    <Route
      key='sip-upi-payment-status'
      path={`${PaymentPageType.SIP}/upi/payment-status`}
      element={<SIPUPIPaymentStatusPage />}
    />, // query: sxpId
    <Route
      key='sip-auto-pay-methods'
      path={`${PaymentPageType.SIP}/auto-pay/methods`}
      element={<AutoPayMethodsPage />}
    />, // query: sxpId — legacy v1 picker (app version < UPI intents)
    // --- V2 UPI autopay (isUpiIntentsFlowEnabled): setup + method picker ---
    <Route
      path={`/v2/${PaymentPageType.SIP}/auto-pay/methods`}
      element={<SetupAutoPay />}
    />, // query: sxpId
    <Route
      key='sip-v2-auto-pay-methods-select'
      path={`/v2/${PaymentPageType.SIP}/auto-pay/methods/select`}
      element={<SetupAutopayMethodsScreen />}
    />, // query: sxpId, amount, sipDate

    <Route
      key='sip-auto-pay-link-waiting'
      path={`${PaymentPageType.SIP}/auto-pay/link-waiting`}
      element={<AutoPayLinkWaitingPage />}
    />, // query: sxpId, mandateId — NET_BANKING only (redirect via `link`)
    <Route
      key='sip-auto-pay-upi-link-waiting'
      path={`${PaymentPageType.SIP}/auto-pay/upi/link-waiting`}
      element={<AutoPayUpiLinkWaitingPage />}
    />, // query: sxpId, mandateId, upiPackageName — UPI_AUTOPAY (`AllStatusWrapper` + intent)
    <Route
      key='sip-auto-pay-payment-failed'
      path={`${PaymentPageType.SIP}/auto-pay/payment-failed`}
      element={<AutoPayPaymentFailedPage />}
    />, // query: sxpId, mandateId
    <Route key='sip-auto-pay-status' path={`${PaymentPageType.SIP}/auto-pay/status`} element={<AutoPayStatusPage />} />, // query: sxpId, mandateId, upiPackageName (optional)

    // Withdraw Routes
    <Route key='withdraw-exit-load' path={`${PaymentPageType.WITHDRAW}/exit-load`} element={<ExitLoadPage />} />, // query: isin, folioNumber, amount
    <Route
      key='withdraw-tax-liability'
      path={`${PaymentPageType.WITHDRAW}/tax-liability`}
      element={<TaxLiabilityPage />}
    /> // query: isin, folioNumber, amount
  ]
}
